import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'styles/tailwind.css';
import 'styles/index.scss';
import App from 'routes/App';
import { store } from 'store';
import { Provider } from 'react-redux';
import 'utils/nativeScripts';
import 'styles/tailwind-utilities.css';
import { ENVIRONMENT } from 'constants/common';
import platform from 'utils/platform';
import * as Sentry from '@sentry/react';
import * as serviceWorker from './serviceWorker';

if (window.SENTRY_DSN) {
  Sentry.init({
    dsn: window.SENTRY_DSN,
    environment: ENVIRONMENT || 'dev',
    tracesSampleRate: window.SENTRY_SAMPLE_RATE || 0,
  });
}

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
);

// Register the service worker only when running in a real browser (web/PWA).
// Inside the native WebView (window.onApp() === true) we skip registration so
// the native app does not over-cache. CRA's own register() still limits the
// effect to production builds.
if (platform.isWeb) {
  serviceWorker.register();
}
